import dealerManage from './dealerManage'
export default dealerManage
